export default __webpack_public_path__ + "static/image2-55d98b896a5a4639b26b711f99c71d88.jpg";